/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationsControllerRemoveBulkMutationRequest, ApplicationsControllerRemoveBulkMutationResponse, ApplicationsControllerRemoveBulk401, ApplicationsControllerRemoveBulk403, ApplicationsControllerRemoveBulk404 } from "../../models/checklistsController/ApplicationsControllerRemoveBulk";

function getApplicationsControllerRemoveBulkUrl() {
  const res = { method: 'DELETE', url: `/api/v1/checklist-applications` as const }  
  return res
}

/**
 * @description Deletes multiple checklist applications. Provide either `ids` for direct application IDs, or `items` with template/scope pairs to find and delete matching applications. When using `ids`, all applications must exist. When using `items`, the operation is idempotent. Requires the create permission on the template kind (Apply/remove reviews or Apply/remove Playbooks) for every id/item.
 * @summary Delete multiple checklist applications (bulk soft delete)
 * {@link /api/v1/checklist-applications}
 */
export async function applicationsControllerRemoveBulk(data?: ApplicationsControllerRemoveBulkMutationRequest, config: Partial<RequestConfig<ApplicationsControllerRemoveBulkMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ApplicationsControllerRemoveBulkMutationResponse, ResponseErrorConfig<ApplicationsControllerRemoveBulk401 | ApplicationsControllerRemoveBulk403 | ApplicationsControllerRemoveBulk404>, ApplicationsControllerRemoveBulkMutationRequest>({ method : "DELETE", url : getApplicationsControllerRemoveBulkUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}